module.exports = __webpack_public_path__ + "static/media/stylized_4_5.d0bcadf2.svg";